import { AccountingPlanEntity } from "../../../entity/AccountingPlanEntity";
import { CsatRatingEntity } from "../../../entity/CsatRatingEntity";

export class FakeLoadingManager {
    constructor(options) {
        this.config = options.config || false;

        // this.configurations = this.getConfigsLoading(key);
    }

    getConfigsLoading(key) {
        if (key === "nucontent_csat") return this.fakeGenerateNucontentCsat();
        if (key === "accounting_plan") return this.fakeGenerateLoadingPlan();
        if (key === "parametrization_edit")
            return this.fakeLoadingParametrizationEdit();
        if (key === "accountings_trialls")
            return this.fakeLoadingAccountingsTrialls();
        if (key === "accountings_customer")
            return this.fakeLoadingAccountingsCostumer();
        if (key === "nps_companies_list") return this.fakeLoadingNps();
        if (key === "companies_list") return this.fakeLoadingCompanies();
        if (key === "accounts_plan_group")
            return this.fakeLoadingAccountsPlanGroup();
        if (key === "group_overview") return this.fakeGenerateGroup();
        if (key === "customization_indicators")
            return this.fakeGenerateIndicators("indicators");
        if (key === "manager-users") return this.fakeGenerateManagerUsers();
        if (key === "reports_list") return this.fakeGenerateReportsList();

        if (key === "dp_importimg") return this.fakeLoadingDpImporting();

        if (key === "parametrizando_on_demand")
            return this.fakeLoadingParametrization();

        if (key === "dp_personnel") return this.fakeGenerateDpPersonnel();

        if (key === "dp_fiscal") return this.fakeGenerateDpFiscal();

        if (key === "dp_financial") return this.fakeGenerateDpFinancial();

        if (key == "dre_demonstrations")
            return {
                columns: this.fakeGenerateMonths("label"),
                rows: this.fakeGenerateDre()
            };

        if (key == "balancete_demonstrations")
            return this.fakeGenerateBalanceSheet();

        if (key == "balance_demonstrations")
            return {
                rows: this.fakeGenerateBalance()
            };

        if (key == "account_plans")
            return {
                months: this.fakeGenerateMonths("name", { value: "R$ 0,00" }),
                series: this.fakeGenerateAccountsPlan()
            };
    }

    fakeGenerateNucontentCsat() {
        const listFake = {
            list: this.fakeGenerate(
                {
                    _id: "idFakeGeneratedFake",
                    email: "oasidoais@nucont.com",
                    name: "01asdas",
                    company: "NUCONT EMPRESA LOADING",
                    accountingId: "accountingIdGenerateFake",
                    status: 1,
                    createdAt: "2023-06-20T17:56:14.458Z",
                    createdBy: "createdByGenerated",
                    csat: [],
                    type: "Outros Contatos",
                    lastCsatReaction: {
                        label: "Sem resposta"
                    }
                },
                20
            ),
            total: 42
        };

        listFake.list = listFake.list.map((l) => {
            const entity = new CsatRatingEntity(l);
            entity.setLastScoreCsatReaction();

            return entity;
        });

        return listFake;
    }
    fakeGenerateLoadingPlan() {
        return this.fakeGenerate(
            new AccountingPlanEntity({
                _id: "adadaddadadasdsad",
                createBy: "adadasdasdsadsa",
                name: "Expert",
                visible: false,
                modules: [
                    {
                        label: "Dashboards",
                        name: "Dashboards",
                        contracted: true,
                        sources: ["accounting"]
                    },
                    {
                        label: "Auditoria",
                        name: "Monitoring",
                        contracted: false,
                        sources: []
                    },
                    {
                        label: "Demonstrações",
                        name: "Demonstrations",
                        contracted: false,
                        sources: []
                    },
                    {
                        label: "Comparações",
                        name: "Comparations",
                        contracted: false,
                        sources: []
                    },
                    {
                        label: "Dash",
                        name: "Reports",
                        contracted: false,
                        sources: []
                    },
                    {
                        label: "Customização Geral",
                        name: "GeneralCustomization",
                        contracted: false,
                        sources: []
                    },
                    {
                        label: "Customização de dashboard",
                        name: "DashboardCustomization",
                        contracted: true,
                        sources: ["personnel"]
                    },
                    {
                        label: "Customização de indicador",
                        name: "IndicatorCustomization",
                        contracted: false,
                        sources: []
                    },
                    {
                        label: "Customização de gráfico",
                        name: "ChartCustomization",
                        contracted: false,
                        sources: []
                    },
                    {
                        label: "Importação em lote",
                        name: "BatchImport",
                        contracted: true,
                        sources: ["fin"]
                    },
                    {
                        label: "Importação PGDAs",
                        name: "PGDAS",
                        contracted: false,
                        sources: []
                    },
                    {
                        label: "Importação eSocial",
                        name: "eSocial",
                        contracted: false,
                        sources: []
                    }
                ],
                features: [
                    {
                        label: "Gestão da Carteira",
                        name: "CompaniesPortfolio",
                        contracted: true
                    },
                    {
                        label: "Gestão do Usuário",
                        name: "UsersManagement",
                        contracted: true
                    },
                    {
                        label: "Suporte",
                        name: "Support",
                        contracted: false
                    },
                    {
                        label: "Nucontent",
                        name: "Nucontent",
                        contracted: true
                    },
                    {
                        label: "Prospect",
                        name: "Prospect",
                        contracted: false
                    },
                    {
                        label: "NPS",
                        name: "NPS",
                        contracted: false
                    },
                    {
                        label: "Logo empresas",
                        name: "Logo",
                        contracted: false
                    },
                    {
                        label: "Paleta de Cores",
                        name: "Themes",
                        contracted: false
                    },
                    {
                        label: "Score",
                        name: "Score",
                        contracted: false
                    },
                    {
                        label: "Análise em Grupo",
                        name: "Groups",
                        contracted: false
                    },
                    {
                        label: "Domínio Contábil",
                        name: "DominioAccounting",
                        contracted: false
                    },
                    {
                        label: "Contabit",
                        name: "Contabit",
                        contracted: false
                    },
                    {
                        label: "Conta Azul",
                        name: "ContaAzul",
                        contracted: false
                    },
                    {
                        label: "Nibo",
                        name: "Nibo",
                        contracted: false
                    },
                    {
                        label: "Fortes",
                        name: "Fortes",
                        contracted: false
                    },
                    {
                        label: "Omie",
                        name: "Omie",
                        contracted: true
                    }
                ],
                createdAt: "2023-05-30T14:23:31.239Z",
                name_nd: "EXPERT",
                totalInUse: 81,
                dateFormatted: "30 mai 2023",
                statusLabel: "Oculto"
            }),
            15
        );
    }

    fakeLoadingParametrizationEdit() {
        return this.fakeGenerate(
            {
                _id: "asdsadsadasda",
                name: "Receitas operacionais",
                classifier: "1",
                code: "1",
                genus: "synthetic",
                compound: [
                    "asd",
                    "adsadadadas",
                    "asdsadsad",
                    "adsadasdas",
                    "sadaasdasdada",
                    "asdasdadasd",
                    "sadsadsadad",
                    "asdasdasdasas",
                    "asdasdadad"
                ],
                associated: ["asdsadsdadsadsa"],
                level: 0
            },
            8
        );
    }
    fakeLoadingAccountingsTrialls() {
        return [...new Array(30)].map(() => ({
            props: {
                _id: "Abcdefghijklasd",
                name: "Trial Nucont Carregar",
                createdAt: "2019-12-16T17:10:59.426Z",
                contact: {
                    contactEmail: "integracao16@nucont.com",
                    owner: "Nucont"
                },
                score: "ALTO",
                status: {
                    internal: "TRIAL E FREE"
                },
                summary: {
                    companies: {
                        total: 88,
                        active: 3,
                        totalFees: 0
                    },
                    employees: {
                        total: 1,
                        hasAccessed: 0
                    },
                    eventsLastRegister: {
                        companies: "2020-04-29T12:49:38.757Z",
                        input: null,
                        report: null,
                        access: null,
                        elapsedCompanies: "2 anos",
                        elapsedAccess: "53 anos"
                    }
                },
                informed: {
                    billing: 0,
                    numberOfCustomers: 0
                },
                formatedScore: {
                    class: "tag-cyan",
                    label: "Alto"
                }
            }
        }));
    }

    fakeLoadingAccountingsCostumer() {
        return [...new Array(30)].map(() => ({
            props: {
                _id: "Abcdefghijkln",
                code: 657,
                name: "Nucotn Contabilidades",
                document: "81981786000177",
                createdAt: "2020-01-31T16:08:01.530Z",
                contact: {
                    contactEmail: "integracaovertice3@nucont.com",
                    financialEmail: "integracaovertice3@nucont.com",
                    owner: "Eugenio"
                },
                responsible: {
                    cs: "[sucesso]",
                    seller: "[vendedor]",
                    csAbbreviation: "S"
                },
                status: {
                    internal: "ATIVO",
                    superlogica: "ATIVO",
                    statusSuperlogicaView: "Ativo"
                },
                score: "ALTO",
                contractDetails: {
                    contract: "Standard",
                    persona: "Carlos",
                    countCompany: 55
                },
                summary: {
                    companies: {
                        total: 186,
                        active: 2,
                        totalFees: 0
                    },
                    employees: {
                        total: 0,
                        hasAccessed: 0
                    },
                    eventsLastRegister: {
                        companies: "2020-04-29T12:49:38.861Z",
                        input: null,
                        report: null,
                        access: null,
                        elapsedCompanies: "2 anos"
                    }
                },
                informed: {
                    billing: 0,
                    numberOfCustomers: 0
                },
                formatedScore: {
                    class: "tag-cyan",
                    label: "Alto"
                }
            }
        }));
    }
    fakeLoadingNps() {
        return [...new Array(15)].map(() => ({
            _id: "ID_NPS_NUCONT",
            name: "Empresa Nucont",
            businessmanContact: {
                name: "Nucont Brasil",
                email: "usuario@nucont.com"
            },
            accountingId: "CONTABILIDADE_ID",
            nps: {
                _id: "NPS_ID_MAPPING",
                accountingId: "CONTABILIDADE_ID",
                companyId: "JLC9bnDNqfjQRssKM",
                email: "usuario.nucont@gmail.com",
                npsId: "ID_NPS_NUCONT",
                events: {
                    sent: "2022-11-30T17:39:52.298Z",
                    answered: "2022-12-07T13:54:49.314Z",
                    commented: "2022-12-07T13:54:49.670Z"
                },

                name: "Usuario Nucont",
                score: 10,
                comment: "Nucont comentando",
                recommendations: [
                    {
                        name: "Nucont Usuario",
                        contact: "(31) 0000-0000",
                        remove: ""
                    },
                    {
                        name: "Usuario Nucont",
                        contact: "(31) 0000-0000",
                        remove: ""
                    }
                ],
                scoreReaction: {
                    icon: "fa-smile",
                    label: "Promotor"
                },
                status: "answered"
            },
            scheduler: true
        }));
    }

    fakeLoadingCompanies() {
        const columns = this.fakeGenerate(
            {
                category: "A",
                name: "Empresa Nucont apresentação",
                c: [{ n: "Lucro Presumido" }, { n: "Serviço" }],
                n: "Serviço",
                status: "ATIVO"
            },
            19
        ).map((c, index) => ({
            ...c,
            o: index + 1
        }));

        return {
            thead: [
                { nc: "Empresas", i: true },
                { nc: "Categoria", i: true },
                { nc: "Grupo do Segmento", i: true },
                { nc: "Segmento", i: true },
                { nc: "Tributação", i: true },
                { nc: "Honorário", i: true },
                { nc: "Entregas", i: true },
                { nc: "Receita", i: true },
                { nc: "Impostos", i: true },
                { nc: "Lucro", i: true },
                { nc: "Contábil", i: true },
                { nc: "Financeiro", i: true },
                { nc: "Pessoal", i: true },
                { nc: "Acesso do Empresário", i: true },
                { nc: "Notificações", i: true },
                { nc: "Início do Contrato", i: true },
                { nc: "Responsável", i: true },
                { nc: "Ativação Nucont", i: true },
                { nc: "Nucontent", i: true }
            ],
            rows: this.fakeGenerate(
                {
                    columns,
                    status: "ATIVO",
                    taxation: "Serviço",
                    segmentGroup: "Serviço"
                },
                7
            ).concat(
                this.fakeGenerate(
                    {
                        columns,
                        status: "ATIVO",
                        taxation: "Lucro Presumido",
                        segmentGroup: "Serviço"
                    },
                    7
                )
            )
        };
    }
    fakeLoadingAccountsPlanGroup() {
        return {
            months: [
                {
                    name: "Janeiro"
                },
                {
                    name: "Fevereito"
                },
                {
                    name: "Março"
                },
                {
                    name: "Abril"
                },
                {
                    name: "Maio"
                },
                {
                    name: "Junho"
                },
                {
                    name: "Julho"
                },
                {
                    name: "Agosto"
                },
                {
                    name: "Setembro"
                },
                {
                    name: "Outubro"
                },
                {
                    name: "Novembro"
                },
                {
                    name: "Dezembro"
                }
            ],
            series: this.fakeGenerate(
                {
                    name: "Faturamento",
                    classifierView: 1,
                    highlight: {
                        bold: true
                    },
                    level: 1
                },
                15
            ),
            monthBody: this.fakeGenerate(
                {
                    value: "R$1.000,00"
                },
                12
            )
        };
    }
    fakeGenerateGroup() {
        return this.fakeGenerate(
            {
                name: "Grupo Nucont empresas A",
                companyNames: ["Nucont", "Empresa Fake", "Google"],
                fees: 100
            },
            15
        );
    }
    fakeGenerateIndicators(type) {
        switch (type) {
            case "indicators":
                return this.fakeGenerate(
                    {
                        document: {},
                        date: "00-00-0000",
                        columnOne: "Empresa indicadores",
                        columnTwo: "Contabil",
                        columnThree: "Acumulado",
                        columnFour: "Dinheiro"
                    },
                    40
                );
        }
    }

    fakeGenerateManagerUsers() {
        return this.fakeGenerate(
            {
                profile: {
                    avatar: false,
                    status: "ATIVO",
                    name: "Nucont Usuário"
                },

                username: "nucontusuario@email.com",
                group: "Empresa",
                lastAccess: false
            },
            15
        );
    }

    fakeGenerateReportsList() {
        return {
            months: ["Março"],
            selecteds: this.fakeGenerate(
                {
                    typeTranslate: "Relatório de Monitoramento",
                    createdAt: "00/00/0000 ás 00:00",
                    sharedBy: "Nome do usuário",
                    vizByFormatted: "-",
                    feedbacksBy: "-"
                },
                11
            )
        };
    }

    fakeLoadingDpImporting() {
        return this.fakeGenerateMonths("month", { type: "Contábil" });
    }

    fakeLoadingParametrization() {
        return {
            table: [],
            cards: [
                {
                    _id: "ABC",
                    totalParameterized: 7,
                    totalChildrensLength: 10,
                    name: "Resultados",
                    childresn: []
                },
                {
                    _id: "ABC",
                    totalParameterized: 4,
                    totalChildrensLength: 13,
                    name: "DRE",
                    childresn: []
                },
                {
                    _id: "ABC",
                    totalParameterized: 10,
                    totalChildrensLength: 10,
                    name: "Folha",
                    childresn: []
                },
                {
                    _id: "ABC",
                    totalParameterized: 7,
                    totalChildrensLength: 10,
                    name: "Resultados",
                    childresn: []
                },
                {
                    _id: "ABC",
                    totalParameterized: 6,
                    totalChildrensLength: 8,
                    name: "Resumo",
                    childresn: []
                },
                {
                    _id: "ABC",
                    totalParameterized: 4,
                    totalChildrensLength: 9,
                    name: "Avaliação",
                    childresn: []
                }
            ]
        };
    }

    fakeGenerateDpPersonnel() {
        return {
            values: this.fakeGenerate(
                {
                    price: "R$ 0,00"
                },
                12
            ),
            titles: [
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Faturamento"
                },
                {
                    id: "abc",
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    opened: true,
                    name: "Total da Folha"
                },
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Número de Funcionários"
                },
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Contratações"
                },
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Demissões"
                }
            ]
        };
    }

    fakeGenerateDpFiscal() {
        return {
            values: this.fakeGenerate(
                {
                    price: "R$ 0,00"
                },
                12
            ),
            titles: [
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Faturamento"
                },
                {
                    id: "abc",
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    opened: true,
                    name: "Total de Impostos"
                },
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Entradas"
                }
            ]
        };
    }

    fakeGenerateDpFinancial() {
        return {
            values: this.fakeGenerate(
                {
                    price: "R$ 0,00"
                },
                12
            ),
            titles: [
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Receitas Operacionais"
                },
                {
                    id: "abc",
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    opened: true,
                    name: "(-) Deduções da Receita Bruta"
                },
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "(-) Custos Operacionais"
                },
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Despesas"
                },
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Atividades de Investimento"
                },
                {
                    id: "abc",
                    opened: false,
                    highlight: {
                        lineColor: true
                    },
                    metadata: {
                        disabled: false,
                        showChart: true
                    },
                    level: 0,
                    name: "Atividades de Financiamento"
                }
            ]
        };
    }

    fakeGenerateBalanceSheet() {
        this.source = "accounting";

        const accountsplan = this.fakeGenerateAccountsPlan();

        const balanceSheet = accountsplan.map((account) => {
            return {
                code: account.classifierView.replace(/\./g, ""),
                classifier: account.classifierView,
                name: account.name,
                o: "R$0.000.000,00",
                d: "R$0.000.000,00",
                c: "R$0.000.000,00",
                f: "R$0.000.000,00"
            };
        });

        return balanceSheet;
    }

    fakeGenerateAccountsPlan() {
        const sources = {
            accounting: [
                { name: "Ativo", classifierView: "1", level: 0 },
                { name: "Ativo Circulante", classifierView: "1.1", level: 1 },
                {
                    name: "Caixa e Equivalentes",
                    classifierView: "1.1.1",
                    level: 2
                },
                { name: "Caixa", classifierView: "1.1.1.1", level: 3 },
                { name: "Bancos", classifierView: "1.1.1.2", level: 3 },
                {
                    name: "Outros Caixa e Equivalentes",
                    classifierView: "1.1.1.3",
                    level: 3
                },
                {
                    name: "Ativos Operacionais",
                    classifierView: "1.1.2",
                    level: 2
                },
                {
                    name: "Clientes a Receber",
                    classifierView: "1.1.2.1",
                    level: 3
                },
                { name: "Estoque", classifierView: "1.1.2.2", level: 3 },
                {
                    name: "Adiantamento a Fornecedores",
                    classifierView: "1.1.2.3",
                    level: 3
                },
                {
                    name: "Outras Contas Operacionais",
                    classifierView: "1.1.2.4",
                    level: 3
                },
                {
                    name: "Ativos Não Operacionais",
                    classifierView: "1.1.3",
                    level: 2
                },
                {
                    name: "Mútuos / Partes Relacionadas",
                    classifierView: "1.1.3.1",
                    level: 3
                },
                {
                    name: "Antecipação de dividendos",
                    classifierView: "1.1.3.2",
                    level: 3
                },
                {
                    name: "Outros Ativos Não Operacionais",
                    classifierView: "1.1.3.3",
                    level: 3
                },
                {
                    name: "Ativo Não Circulante",
                    classifierView: "1.2",
                    level: 1
                },
                { name: "Imobilizado", classifierView: "1.2.1", level: 2 },
                {
                    name: "Imobilizado Bruto",
                    classifierView: "1.2.1.1",
                    level: 3
                },
                {
                    name: "(-) Depreciação Acumulada",
                    classifierView: "1.2.1.2",
                    level: 3
                },
                {
                    name: "Demais Ativos Não Circulantes",
                    classifierView: "1.2.2",
                    level: 2
                }
            ],

            financial: [
                { name: "Receitas Operacionais", level: 0 },
                { name: "Receita de Vendas", level: 1 },
                { name: "Receita de Serviço", level: 1 },
                { name: "Outras Receitas Operacionais", level: 1 },
                { name: "Deduções da Receita Bruta", level: 0 },
                { name: "Impostos sobre Vendas", level: 1 },
                { name: "Cancelamentos e Devoluções", level: 1 },
                { name: "Descontos Incodicionais", level: 1 },
                { name: "Outras Deduções", level: 1 },
                { name: "Custos Operacionais", level: 0 },
                { name: "Custos de Vendas", level: 1 },
                { name: "Compra de Mercadoria", level: 2 },
                { name: "Custos com Pessoal de Vendas", level: 2 },
                { name: "Outros Custos de Vendas", level: 2 },
                { name: "Custos dos Seviços Prestados", level: 1 }
            ],

            tax: [
                { name: "Faturamento", level: 0 },
                { name: "Faturamento A", level: 1 },
                { name: "Faturamento B", level: 1 },
                { name: "Faturamento Extra A", level: 1 },
                { name: "Total de Impostos", level: 0 },
                { name: "Total de Impostos Federais", level: 1 },
                { name: "Simples Nacional", level: 2 },
                { name: "Demais", level: 2 },
                { name: "Impostos Extra A", level: 2 },
                { name: "Total de Impostos Estaduais", level: 1 },
                { name: "Total de Impostos Municipais", level: 1 }
            ]
        };

        return sources[this.source] || [];
    }

    fakeGenerateBalance() {
        const balanceList = [
            {
                labelx: "Ativo Circulante",
                labely: "Passivo Circulante",
                isTitle: true
            },

            {
                labelx: "Caixa e Equivalentes",
                labely: "Passivos Financeiros",
                isTitle: false
            },
            {
                labelx: "Clientes a Receber",
                labely: "Fornecedores a Pagar",
                isTitle: false
            },
            {
                labelx: "Estoque",
                labely: "Obrigações Fiscais",
                isTitle: false
            },
            {
                labelx: "Adiantamento a Fornecedores",
                labely: "Obrigações Trabalhistas",
                isTitle: false
            },
            {
                labelx: "Outros Ativos Operacionais",
                labely: "Provisões Trabalhistas",
                isTitle: false
            },
            {
                labelx: "Mútuos e Partes Relacionadas",
                labely: "Adiantamento de Clientes",
                isTitle: false
            },
            {
                labelx: "Antecipação de Dividendos",
                labely: "Outros Passivos Operacionais",
                isTitle: false
            },
            {
                labelx: "Ativo Não Circulante",
                labely: "Passivo Não Circulante",
                isTitle: true
            },
            {
                labelx: "Ativo Não Circulante",
                labely: "Passivo Não Circulante",
                isTitle: false
            },
            {
                labelx: "Imobilizado",
                labely: "Mútuos / Partes Relacionadas",
                isTitle: false
            },
            {
                labelx: "Mútuos / Partes Relacionadas",
                labely: "Outros Passivos Não Circulantes",
                isTitle: false
            },
            {
                labelx: "Outros Ativos Não Circulantes",
                labely: "Patrimonio Líquido",
                isTitle: false
            }
        ];

        const balanceFake = balanceList.map((balance) => {
            const fake = {
                asset: {
                    title: balance.labelx,
                    isTitle: balance.isTitle,
                    verticalAnalysisFormatted: this.generatePrice(),
                    pointFormatted: this.generatePercentage()
                },
                liability: {
                    title: balance.labely,
                    isTitle: balance.isTitle,
                    pointFormatted: this.generatePrice(),
                    verticalAnalysisFormatted: this.generatePercentage()
                }
            };

            return fake;
        });

        return balanceFake;
    }

    fakeGenerateDre() {
        const dre = [
            "Receita Bruta",
            "Deduções da Receita Bruta",
            "(=) Receita Líquida",
            "(-) Custos",
            "(=) Lucro Bruto",
            "(%) Margem Bruta",
            "(-) Despesas Operacionais",
            "(=) EBITDA",
            "(%) Margem EBITDA",
            "(-) Depreciação e Amortização",
            "(=) EBIT",
            "(%) Margem EBIT",
            "(±) Resultado Financeiro",
            "(±) Outras Receitas e Outras Despesas",
            "(-) Provisão para Imposto de Renda e Contribuição Social"
        ];

        return dre.map((name) => {
            return {
                name: name,
                bold: true,
                points: this.fakeGenerate({
                    valueFormatted: "R$ 00,00",
                    accumulatedFormatted: "R$ 00,00",
                    verticalAnalysisFormatted: "R$ 00,00"
                })
            };
        });
    }

    fakeGenerateMonths(key, fields) {
        const months = [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro"
        ];

        return months.map((month) => {
            return { [key]: month, ...fields };
        });
    }
    /**
     *
     * @param {*} name
     * @param {*} dataCopy
     * @returns {Object} criar um novo modelo fake para loading
     */
    create(name, dataCopy) {
        if (this.configurations[name]) return false;
        this.configurations[name] = dataCopy;
    }
    /**
     * @public
     * @returns
     */
    generate(source = "default") {
        this.source = source;

        return this.getConfigsLoading(this.config);
    }

    generatePercentage() {
        return "0,0%";
    }
    /**
     * @public
     * @returns {String} gerar preço formatado fake
     */
    generatePrice() {
        return "R$ 0,00";
    }

    /**
     *
     * @param {*} numberMax
     * @returns {Number} gerar numeros aleatórios
     */
    generateRandomNumbers(numberMax = 2000) {
        const random = Math.floor(Math.random() * numberMax);
        return random;
    }
    /**
     *
     * @param {*} values
     * @param {*} numberOfRepetitions
     * @returns {Array}  gera um objeto fake para loading
     */

    fakeGenerate(value, numberOfRepetitions = 11) {
        const response = [];

        for (let i = 0; i < numberOfRepetitions; i++) {
            response.push(value);
        }

        return response;
    }
}
